/* "Read more" box for snippets/citron-seo-readmore.liquid.

   The server renders the copy fully open with the button hidden. This only
   collapses it after measuring that the copy is actually taller than the
   collapsed height -- short copy keeps no button at all, and a browser without
   JS shows everything. */
if (!customElements.get('citron-readmore')) {
  customElements.define(
    'citron-readmore',
    class extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-ctr-readmore-body]');
        this.toggle = this.querySelector('[data-ctr-readmore-toggle]');
        this.label = this.querySelector('[data-ctr-readmore-label]');
        this.sign = this.querySelector('[data-ctr-readmore-sign]');
        if (!this.body || !this.toggle) return;

        const limit = parseFloat(getComputedStyle(this).getPropertyValue('--ctr-seo-collapsed')) || 230;
        // A little slack: clamping away two lines to save one is not worth a button.
        if (this.body.scrollHeight <= limit + 48) return;

        this.classList.add('is-collapsible');
        this.toggle.hidden = false;
        this.set(false);
        this.toggle.addEventListener('click', () => {
          const open = this.toggle.getAttribute('aria-expanded') !== 'true';
          this.set(open);
          // Closing from far down the copy would leave the reader below it.
          if (!open && this.getBoundingClientRect().top < 0) {
            this.scrollIntoView({ block: 'start', behavior: 'smooth' });
          }
        });
        // Tabbing onto a link inside the clipped part opens the box, so focus
        // never lands somewhere the reader can't see.
        this.body.addEventListener('focusin', () => {
          if (this.classList.contains('is-collapsed')) this.set(true);
        });
      }

      set(open) {
        this.classList.toggle('is-collapsed', !open);
        this.toggle.setAttribute('aria-expanded', String(open));
        if (this.label) this.label.textContent = open ? 'Read less' : 'Read more';
        if (this.sign) this.sign.textContent = open ? '−' : '+';
      }
    }
  );
}
